function NotFound() {
  return (
    <div className="margin-y-11x header-normal flex hcenter txt-center margin-x-3x">
      The creator you are looking for does not exist.
    </div>
  )
}

export { NotFound }
